import { createTheme } from '@mui/material';

const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, san-serif',
    h2: {
      fontFamily: 'Font1, Brogadier, serif',
    },
    body1: {
      fontFamily: 'Poppins, san-serif',
    },
    body2: {
      fontFamily: 'Font2, Cera Pro, san-serif',
    },
  },
});

export default theme;
